import Header from './header';
import ViewControlHeader from './v2/view_control_header';
import HeaderControlWrapper, {
  constants as headerControlWrapperConstants,
} from './v2/base_view_control_header';
import SavedViewsComponent, { constants as savedViewsConstants } from './v2/saved_views';

const headerConstants = {
  headerControlWrapper: headerControlWrapperConstants,
};

export { Header, ViewControlHeader, HeaderControlWrapper, headerConstants, SavedViewsComponent, savedViewsConstants };
